(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
const url = new URL(window.location.href);
if (url.hash) { document.addEventListener('DOMContentLoaded', () => { const card = document.getElementById(url.hash.slice(1)); if (card) card.scrollIntoView({behavior:'instant'}); }, {once:true}); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mox-buyback-form"] && !Shopify.designMode) return;
  try {
    
function initializeMoxBuyback(root) {
  if (root.dataset.initialized) return;
  const form = root.querySelector('form'), method = root.querySelector('#MoxMethod');
  if (!form || !method) return;
  root.dataset.initialized = 'true';
  const get = selector => root.querySelector(selector);
  const rows = [...root.querySelectorAll('[data-rate]')];
  const weights = rows.map(row => row.querySelector('input'));
  const cards = get('#MoxCards'), error = get('[data-error-text]');
  const id = get('[name="contact[simulation_id]"]');
  const numberLocale = root.dataset.locale.startsWith('fr') ? 'fr-FR' : 'en-IE';
  const money = cents => (cents / 100).toLocaleString(numberLocale, { style: 'currency', currency: 'EUR' });
  const resetId = () => { id.value = 'MOX-' + crypto.randomUUID(); };
  function calculate() {
    const grams = weights.map(input => Math.round(Number(input.value) * 1000));
    const weight = grams.reduce((a, b) => a + b, 0);
    const validWeights = weights.every(input => input.validity.valid && Number.isFinite(Number(input.value)) && Number(input.value) >= 0);
    const valid = validWeights && (weight === 0 || weight >= 200);
    const cents = Math.round(grams.reduce((sum, amount, i) => sum + amount * Number(rows[i].dataset.rate), 0) / 10);
    rows.forEach((row, i) => { row.querySelector('[data-line-total]').textContent = valid ? money(Math.round(grams[i] * Number(row.dataset.rate) / 10)) : root.dataset.check; });
    get('[data-cash]').textContent = valid ? money(cents) : root.dataset.check;
    get('[data-credit]').textContent = valid ? money(Math.floor(cents * 105 / 100)) : root.dataset.check;
    get('[data-weight]').textContent = Number.isFinite(weight) ? (weight / 1000).toLocaleString(numberLocale) + ' kg' : '—';
    get('[data-estimate-message]').textContent = !validWeights ? root.dataset.error : weight === 0 ? root.dataset.empty : weight < 200 ? root.dataset.minimum : '';
    return { valid, weight, grams, cents };
  }
  function changeMode() {
    const isBulk = method.value === 'bulk';
    get('[data-bulk]').hidden = !isBulk; get('[data-list]').hidden = isBulk;
    get('[data-bulk-estimate]').hidden = !isBulk; get('[data-list-estimate]').hidden = isBulk;
    weights.forEach(input => { input.disabled = !isBulk || Number(input.max) === 0; });
    cards.disabled = isBulk; cards.required = !isBulk; get('#MoxImport').disabled = isBulk;
    error.textContent = ''; resetId(); calculate();
  }
  get('#MoxImport').addEventListener('change', async event => {
    const file = event.target.files[0]; if (!file) return;
    if (file.size > 60000 || !/\.(txt|csv)$/i.test(file.name)) { error.textContent = root.dataset.fileError; event.target.value = ''; return; }
    try { const text = await file.text(); if (text.length > 30000) throw new Error('size'); cards.value = text; error.textContent = ''; get('[data-file-status]').textContent = root.dataset.importOk; resetId(); }
    catch { error.textContent = root.dataset.fileError; }
  });
  method.addEventListener('change', changeMode);
  form.addEventListener('input', () => { resetId(); calculate(); });
  form.addEventListener('submit', event => {
    const result = calculate();
    const valid = method.value === 'bulk' ? result.valid && result.weight >= 200 : cards.value.trim().length > 0;
    if (!valid || !form.checkValidity()) { event.preventDefault(); error.textContent = method.value === 'bulk' && result.weight > 0 && result.weight < 200 ? root.dataset.minimum : root.dataset.error; form.reportValidity(); return; }
    get('[name="contact[recapitulatif]"]').value = method.value === 'bulk'
      ? rows.map((row,i) => row.dataset.name + ' : ' + (result.grams[i]/1000) + ' kg × ' + row.dataset.rate + ' EUR/kg = ' + money(Math.round(result.grams[i]*Number(row.dataset.rate)/10))).join('\n') + '\n' + money(result.cents) + ' / ' + money(Math.floor(result.cents*105/100))
      : get('[data-list-estimate]').textContent.trim();
    error.textContent = '';
  });
  changeMode(); get('button[type=submit]').disabled = false;
}
document.querySelectorAll('[data-mox-buyback]').forEach(initializeMoxBuyback);
document.addEventListener('shopify:section:load', event => { event.target.querySelectorAll('[data-mox-buyback]').forEach(initializeMoxBuyback); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mox-collection-before-mobile-0210"]) return;
  try {
    
const url = new URL(window.location.href);
if (url.hash) { document.addEventListener('DOMContentLoaded', () => { const card = document.getElementById(url.hash.slice(1)); if (card) card.scrollIntoView({behavior:'instant'}); }, {once:true}); }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mox-drop-slideshow"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('mox-drop-slideshow'))customElements.define('mox-drop-slideshow',class extends HTMLElement{
    connectedCallback(){
      this.lifecycle?.abort();
      this.lifecycle=new AbortController();
      const signal=this.lifecycle.signal;
      const track=this.querySelector('.mox-drop-slideshow__track');
      const slides=Array.from(track.children);
      const hydrate=(slide)=>{
        slide?.querySelectorAll('template[data-deferred-slide]').forEach(template=>{
          template.replaceWith(template.content.cloneNode(true));
        });
      };
      const hydrateFollowing=()=>{
        if(!signal.aborted)slides.slice(1).forEach(hydrate);
      };
      // Keep the following slide out of the initial image request queue.
      const deferFollowing=()=>{this.imageTimer=setTimeout(hydrateFollowing,1200);};
      if(document.readyState==='complete')deferFollowing();
      else window.addEventListener('load',deferFollowing,{once:true,signal});
      track.addEventListener('pointerdown',hydrateFollowing,{passive:true,signal});
      track.addEventListener('touchstart',hydrateFollowing,{passive:true,signal});
      const selectors=this.querySelectorAll('[data-slide]');
      const motion=matchMedia('(prefers-reduced-motion: reduce)');
      this.current=0;
      this.target=null;
      this.interacting=false;
      let width=0;
      const nearest=()=>width>0?Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/width))):this.current;
      const update=()=>{
        this.current=nearest();
        selectors.forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.slide)===this.current)));
      };
      const stop=()=>clearTimeout(this.timer);
      const schedule=()=>{
        stop();
        if(!this.hasAttribute('data-rotate')||slides.length<2||motion.matches)return;
        this.timer=setTimeout(()=>{
          if(!document.hidden&&!this.interacting&&!this.contains(document.activeElement)&&!this.matches(':hover')&&this.target===null)move(this.current+1);
          schedule();
        },8000);
      };
      const settle=()=>{update();this.target=null;schedule();};
      const move=(index,instant=false)=>{
        this.target=(index+slides.length)%slides.length;
        hydrate(slides[this.target]);
        stop();
        track.scrollTo({left:(width||track.clientWidth)*this.target,behavior:instant||motion.matches?'instant':'smooth'});
        clearTimeout(this.settling);
        this.settling=setTimeout(settle,200);
      };
      track.addEventListener('scroll',()=>{
        update();
        clearTimeout(this.settling);
        this.settling=setTimeout(settle,160);
      },{passive:true,signal});
      selectors.forEach(button=>button.addEventListener('click',()=>move(Number(button.dataset.slide)),{signal}));
      this.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>move((this.target??this.current)+Number(button.dataset.direction)),{signal}));
      track.addEventListener('keydown',event=>{
        if(event.target!==track)return;
        if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
          event.preventDefault();
          move((this.target??this.current)+(event.key==='ArrowRight'?1:-1));
        }
      },{signal});
      track.addEventListener('pointerdown',()=>{this.interacting=true;this.target=null;stop();},{passive:true,signal});
      const release=()=>{this.interacting=false;schedule();};
      window.addEventListener('pointerup',release,{passive:true,signal});
      window.addEventListener('pointercancel',release,{passive:true,signal});
      track.addEventListener('touchstart',()=>{this.interacting=true;stop();},{passive:true,signal});
      track.addEventListener('touchend',release,{passive:true,signal});
      track.addEventListener('touchcancel',release,{passive:true,signal});
      this.addEventListener('mouseenter',stop,{signal});
      this.addEventListener('mouseleave',schedule,{signal});
      this.addEventListener('focusin',stop,{signal});
      this.addEventListener('focusout',schedule,{signal});
      document.addEventListener('visibilitychange',()=>document.hidden?stop():schedule(),{signal});
      motion.addEventListener('change',schedule,{signal});
      this.sizing=new ResizeObserver(entries=>{
        const nextWidth=entries[0]?.contentRect.width;
        if(!nextWidth||width===nextWidth)return;
        const initialized=width>0;
        width=nextWidth;
        if(initialized)move(this.target??this.current,true);
        else update();
      });
      this.sizing.observe(track);
      const firstImage=slides[0]?.querySelector('img');
      if(firstImage?.complete)schedule();
      else firstImage?.addEventListener('load',schedule,{once:true,signal});
    }
    disconnectedCallback(){
      clearTimeout(this.timer);
      clearTimeout(this.settling);
      clearTimeout(this.imageTimer);
      this.lifecycle?.abort();
      this.sizing?.disconnect();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mox-gundam-slideshow"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('mox-gundam-slideshow'))customElements.define('mox-gundam-slideshow',class extends HTMLElement{
    connectedCallback(){
      this.lifecycle?.abort();
      this.lifecycle=new AbortController();
      const signal=this.lifecycle.signal;
      const track=this.querySelector('.mox-gundam-slideshow__track');
      const slides=Array.from(track.children);
      const hydrate=(slide)=>{
        slide?.querySelectorAll('template[data-deferred-slide]').forEach(template=>{
          template.replaceWith(template.content.cloneNode(true));
        });
      };
      const hydrateFollowing=()=>{
        if(!signal.aborted)slides.slice(1).forEach(hydrate);
      };
      // Keep the following slide out of the initial image request queue.
      const deferFollowing=()=>{this.imageTimer=setTimeout(hydrateFollowing,1200);};
      if(document.readyState==='complete')deferFollowing();
      else window.addEventListener('load',deferFollowing,{once:true,signal});
      track.addEventListener('pointerdown',hydrateFollowing,{passive:true,signal});
      track.addEventListener('touchstart',hydrateFollowing,{passive:true,signal});
      const selectors=this.querySelectorAll('[data-slide]');
      const motion=matchMedia('(prefers-reduced-motion: reduce)');
      this.current=0;
      this.target=null;
      this.interacting=false;
      let width=0;
      const nearest=()=>width>0?Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/width))):this.current;
      const update=()=>{
        this.current=nearest();
        selectors.forEach(button=>{
          const pressed=String(Number(button.dataset.slide)===this.current);
          if(button.getAttribute('aria-pressed')!==pressed)button.setAttribute('aria-pressed',pressed);
        });
      };
      const stop=()=>clearTimeout(this.timer);
      const schedule=()=>{
        stop();
        if(!this.hasAttribute('data-rotate')||slides.length<2||motion.matches)return;
        this.timer=setTimeout(()=>{
          if(!document.hidden&&!this.interacting&&!this.contains(document.activeElement)&&!this.matches(':hover')&&this.target===null)move(this.current+1);
          schedule();
        },8000);
      };
      const settle=()=>{update();this.target=null;schedule();};
      const move=(index,instant=false)=>{
        this.target=(index+slides.length)%slides.length;
        hydrate(slides[this.target]);
        stop();
        track.scrollTo({left:(width||track.clientWidth)*this.target,behavior:instant||motion.matches?'instant':'smooth'});
        clearTimeout(this.settling);
        this.settling=setTimeout(settle,200);
      };
      track.addEventListener('scroll',()=>{
        update();
        clearTimeout(this.settling);
        this.settling=setTimeout(settle,160);
      },{passive:true,signal});
      selectors.forEach(button=>button.addEventListener('click',()=>move(Number(button.dataset.slide)),{signal}));
      this.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>move((this.target??this.current)+Number(button.dataset.direction)),{signal}));
      track.addEventListener('keydown',event=>{
        if(event.target!==track)return;
        if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
          event.preventDefault();
          move((this.target??this.current)+(event.key==='ArrowRight'?1:-1));
        }
      },{signal});
      track.addEventListener('pointerdown',()=>{this.interacting=true;this.target=null;stop();},{passive:true,signal});
      const release=()=>{this.interacting=false;schedule();};
      window.addEventListener('pointerup',release,{passive:true,signal});
      window.addEventListener('pointercancel',release,{passive:true,signal});
      track.addEventListener('touchstart',()=>{this.interacting=true;stop();},{passive:true,signal});
      track.addEventListener('touchend',release,{passive:true,signal});
      track.addEventListener('touchcancel',release,{passive:true,signal});
      this.addEventListener('mouseenter',stop,{signal});
      this.addEventListener('mouseleave',schedule,{signal});
      this.addEventListener('focusin',stop,{signal});
      this.addEventListener('focusout',schedule,{signal});
      document.addEventListener('visibilitychange',()=>document.hidden?stop():schedule(),{signal});
      motion.addEventListener('change',schedule,{signal});
      this.sizing=new ResizeObserver(entries=>{
        const nextWidth=entries[0]?.contentRect.width;
        if(!nextWidth||width===nextWidth)return;
        const initialized=width>0;
        width=nextWidth;
        if(initialized)move(this.target??this.current,true);
        else update();
      });
      this.sizing.observe(track);
      const firstImage=slides[0]?.querySelector('img');
      if(firstImage?.complete)schedule();
      else firstImage?.addEventListener('load',schedule,{once:true,signal});
    }
    disconnectedCallback(){
      clearTimeout(this.timer);
      clearTimeout(this.settling);
      clearTimeout(this.imageTimer);
      this.lifecycle?.abort();
      this.sizing?.disconnect();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mox-mystery-product"]) return;
  try {
    
document.addEventListener('click', event => {
  const button = event.target.closest('[data-pack-step]');
  if (!button) return;
  const control = button.closest('.mox-pack-quantity');
  const input = control.querySelector('input');
  if (input.disabled) return;
  if (Number(button.dataset.packStep) > 0) input.stepUp(); else input.stepDown();
  input.dispatchEvent(new Event('input', {bubbles:true}));
});
document.addEventListener('input', event => {
  if (!event.target.matches('.mox-pack-quantity input')) return;
  const input = event.target, control = input.closest('.mox-pack-quantity');
  control.querySelector('[data-pack-step="-1"]').disabled = Number(input.value) <= Number(input.min);
  control.querySelector('[data-pack-step="1"]').disabled = input.max !== '' && Number(input.value) >= Number(input.max);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mox-products-before-recette"] && !Shopify.designMode) return;
  try {
    
class ProductListStockCount extends HTMLElement {
connectedCallback() {
if (this._placing) return;
if (!this._resizeBound) { this._onResize = () => { clearTimeout(this._resizeTimer); this._resizeTimer = setTimeout(() => this.place(), 150); }; window.addEventListener('resize', this._onResize); this._resizeBound = true; }
requestAnimationFrame(() => this.place());
}
getActivePosition() { const desktop = this.dataset.position || 'right'; const mobile = this.dataset.positionMobile || desktop; return window.matchMedia('(max-width: 749px)').matches ? mobile : desktop; }
place() {
if (this._placing || !this.isConnected) return;
const position = this.getActivePosition();
if (this.dataset.placed === 'true' && this.dataset.activePosition === position) return;
const header = this.closest('.product-list-header');
if (!header) return;
const titleRoot = header.querySelector('h1, h2, h3, h4, h5, h6, .text-block, [class*="text-block"]');
if (!titleRoot || !titleRoot.parentElement) return;
const heading = titleRoot.matches('h1, h2, h3, h4, h5, h6') ? titleRoot : titleRoot.querySelector('h1, h2, h3, h4, h5, h6') || titleRoot;
const titleBlock = titleRoot.closest('.text-block, [class*="text-block"]') || titleRoot;
const row = titleBlock.parentElement;
if (!row) return;
this._placing = true;
let titleGroup = row.querySelector(':scope > .product-list-header__title-group');
if (!titleGroup) { titleGroup = document.createElement('div'); titleGroup.className = 'product-list-header__title-group'; row.insertBefore(titleGroup, titleBlock); titleGroup.appendChild(titleBlock); } else if (titleBlock.parentElement !== titleGroup) titleGroup.appendChild(titleBlock);
titleGroup.classList.remove('product-list-header__title-group--above', 'product-list-header__title-group--below', 'product-list-header__title-group--right');
titleGroup.classList.add(`product-list-header__title-group--${position}`);
heading.classList.add('product-list-header__heading');
const alreadyCorrect = (position === 'above' && this.parentElement === titleGroup && this.nextElementSibling === titleBlock) || (position === 'below' && this.parentElement === titleGroup && titleGroup.lastElementChild === this) || (position === 'right' && this.parentElement === heading);
if (!alreadyCorrect) { if (position === 'above') titleGroup.insertBefore(this, titleBlock); else if (position === 'below') titleGroup.appendChild(this); else heading.appendChild(this); }
this.dataset.placed = 'true'; this.dataset.activePosition = position; this._placing = false;
}
}
if (!customElements.get('product-list-stock-count')) customElements.define('product-list-stock-count', ProductListStockCount);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moxcards-backup-product-list-20260929"] && !Shopify.designMode) return;
  try {
    
  class ProductListStockCount extends HTMLElement {
    connectedCallback() {
      if (this._placing) return;

      if (!this._resizeBound) {
        this._onResize = () => {
          clearTimeout(this._resizeTimer);
          this._resizeTimer = setTimeout(() => this.place(), 150);
        };
        window.addEventListener('resize', this._onResize);
        this._resizeBound = true;
      }

      // Never move this node synchronously in connectedCallback —
      // relocating a custom element retriggers connect/disconnect forever.
      requestAnimationFrame(() => this.place());
    }

    getActivePosition() {
      const desktop = this.dataset.position || 'right';
      const mobile = this.dataset.positionMobile || desktop;
      return window.matchMedia('(max-width: 749px)').matches ? mobile : desktop;
    }

    place() {
      if (this._placing || !this.isConnected) return;

      const position = this.getActivePosition();
      if (this.dataset.placed === 'true' && this.dataset.activePosition === position) {
        return;
      }

      const header = this.closest('.product-list-header');
      if (!header) return;

      const titleRoot = header.querySelector(
        'h1, h2, h3, h4, h5, h6, .text-block, [class*="text-block"]'
      );
      if (!titleRoot || !titleRoot.parentElement) return;

      const heading = titleRoot.matches('h1, h2, h3, h4, h5, h6')
        ? titleRoot
        : titleRoot.querySelector('h1, h2, h3, h4, h5, h6') || titleRoot;

      const titleBlock =
        titleRoot.closest('.text-block, [class*="text-block"]') || titleRoot;
      const row = titleBlock.parentElement;
      if (!row) return;

      this._placing = true;

      let titleGroup = row.querySelector(':scope > .product-list-header__title-group');
      if (!titleGroup) {
        titleGroup = document.createElement('div');
        titleGroup.className = 'product-list-header__title-group';
        row.insertBefore(titleGroup, titleBlock);
        titleGroup.appendChild(titleBlock);
      } else if (titleBlock.parentElement !== titleGroup) {
        titleGroup.appendChild(titleBlock);
      }

      titleGroup.classList.remove(
        'product-list-header__title-group--above',
        'product-list-header__title-group--below',
        'product-list-header__title-group--right'
      );
      titleGroup.classList.add(`product-list-header__title-group--${position}`);
      heading.classList.add('product-list-header__heading');

      const alreadyCorrect =
        (position === 'above' &&
          this.parentElement === titleGroup &&
          this.nextElementSibling === titleBlock) ||
        (position === 'below' &&
          this.parentElement === titleGroup &&
          titleGroup.lastElementChild === this) ||
        (position === 'right' && this.parentElement === heading);

      if (!alreadyCorrect) {
        if (position === 'above') {
          titleGroup.insertBefore(this, titleBlock);
        } else if (position === 'below') {
          titleGroup.appendChild(this);
        } else {
          heading.appendChild(this);
        }
      }

      this.dataset.placed = 'true';
      this.dataset.activePosition = position;
      this._placing = false;
    }
  }

  if (!customElements.get('product-list-stock-count')) {
    customElements.define('product-list-stock-count', ProductListStockCount);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moxcards-collection-before-finitions"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moxcards-home-before-auto-20260929"] && !Shopify.designMode) return;
  try {
    
  class ProductListStockCount extends HTMLElement {
    connectedCallback() {
      if (this._placing) return;

      if (!this._resizeBound) {
        this._onResize = () => {
          clearTimeout(this._resizeTimer);
          this._resizeTimer = setTimeout(() => this.place(), 150);
        };
        window.addEventListener('resize', this._onResize);
        this._resizeBound = true;
      }

      // Never move this node synchronously in connectedCallback —
      // relocating a custom element retriggers connect/disconnect forever.
      requestAnimationFrame(() => this.place());
    }

    getActivePosition() {
      const desktop = this.dataset.position || 'right';
      const mobile = this.dataset.positionMobile || desktop;
      return window.matchMedia('(max-width: 749px)').matches ? mobile : desktop;
    }

    place() {
      if (this._placing || !this.isConnected) return;

      const position = this.getActivePosition();
      if (this.dataset.placed === 'true' && this.dataset.activePosition === position) {
        return;
      }

      const header = this.closest('.product-list-header');
      if (!header) return;

      const titleRoot = header.querySelector(
        'h1, h2, h3, h4, h5, h6, .text-block, [class*="text-block"]'
      );
      if (!titleRoot || !titleRoot.parentElement) return;

      const heading = titleRoot.matches('h1, h2, h3, h4, h5, h6')
        ? titleRoot
        : titleRoot.querySelector('h1, h2, h3, h4, h5, h6') || titleRoot;

      const titleBlock =
        titleRoot.closest('.text-block, [class*="text-block"]') || titleRoot;
      const row = titleBlock.parentElement;
      if (!row) return;

      this._placing = true;

      let titleGroup = row.querySelector(':scope > .product-list-header__title-group');
      if (!titleGroup) {
        titleGroup = document.createElement('div');
        titleGroup.className = 'product-list-header__title-group';
        row.insertBefore(titleGroup, titleBlock);
        titleGroup.appendChild(titleBlock);
      } else if (titleBlock.parentElement !== titleGroup) {
        titleGroup.appendChild(titleBlock);
      }

      titleGroup.classList.remove(
        'product-list-header__title-group--above',
        'product-list-header__title-group--below',
        'product-list-header__title-group--right'
      );
      titleGroup.classList.add(`product-list-header__title-group--${position}`);
      heading.classList.add('product-list-header__heading');

      const alreadyCorrect =
        (position === 'above' &&
          this.parentElement === titleGroup &&
          this.nextElementSibling === titleBlock) ||
        (position === 'below' &&
          this.parentElement === titleGroup &&
          titleGroup.lastElementChild === this) ||
        (position === 'right' && this.parentElement === heading);

      if (!alreadyCorrect) {
        if (position === 'above') {
          titleGroup.insertBefore(this, titleBlock);
        } else if (position === 'below') {
          titleGroup.appendChild(this);
        } else {
          heading.appendChild(this);
        }
      }

      this.dataset.placed = 'true';
      this.dataset.activePosition = position;
      this._placing = false;
    }
  }

  if (!customElements.get('product-list-stock-count')) {
    customElements.define('product-list-stock-count', ProductListStockCount);
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
class ProductListStockCount extends HTMLElement {
connectedCallback() {
if (this._placing) return;
if (!this._resizeBound) { this._onResize = () => { clearTimeout(this._resizeTimer); this._resizeTimer = setTimeout(() => this.place(), 150); }; window.addEventListener('resize', this._onResize); this._resizeBound = true; }
requestAnimationFrame(() => this.place());
}
getActivePosition() { const desktop = this.dataset.position || 'right'; const mobile = this.dataset.positionMobile || desktop; return window.matchMedia('(max-width: 749px)').matches ? mobile : desktop; }
place() {
if (this._placing || !this.isConnected) return;
const position = this.getActivePosition();
if (this.dataset.placed === 'true' && this.dataset.activePosition === position) return;
const header = this.closest('.product-list-header');
if (!header) return;
const titleRoot = header.querySelector('h1, h2, h3, h4, h5, h6, .text-block, [class*="text-block"]');
if (!titleRoot || !titleRoot.parentElement) return;
const heading = titleRoot.matches('h1, h2, h3, h4, h5, h6') ? titleRoot : titleRoot.querySelector('h1, h2, h3, h4, h5, h6') || titleRoot;
const titleBlock = titleRoot.closest('.text-block, [class*="text-block"]') || titleRoot;
const row = titleBlock.parentElement;
if (!row) return;
this._placing = true;
let titleGroup = row.querySelector(':scope > .product-list-header__title-group');
if (!titleGroup) { titleGroup = document.createElement('div'); titleGroup.className = 'product-list-header__title-group'; row.insertBefore(titleGroup, titleBlock); titleGroup.appendChild(titleBlock); } else if (titleBlock.parentElement !== titleGroup) titleGroup.appendChild(titleBlock);
titleGroup.classList.remove('product-list-header__title-group--above', 'product-list-header__title-group--below', 'product-list-header__title-group--right');
titleGroup.classList.add(`product-list-header__title-group--${position}`);
heading.classList.add('product-list-header__heading');
const alreadyCorrect = (position === 'above' && this.parentElement === titleGroup && this.nextElementSibling === titleBlock) || (position === 'below' && this.parentElement === titleGroup && titleGroup.lastElementChild === this) || (position === 'right' && this.parentElement === heading);
if (!alreadyCorrect) { if (position === 'above') titleGroup.insertBefore(this, titleBlock); else if (position === 'below') titleGroup.appendChild(this); else heading.appendChild(this); }
this.dataset.placed = 'true'; this.dataset.activePosition = position; this._placing = false;
}
}
if (!customElements.get('product-list-stock-count')) customElements.define('product-list-stock-count', ProductListStockCount);

  } catch(e) { console.error(e); }
})();
})();
